var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTerra(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M35.99 17.98c0 9.93-8.06 17.98-18 17.98a17.98 17.98 0 1 1 18-17.98"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2043B5",
    d: "M15.58 27.14c.93 3.33 4.26 5.88 5.94 5.77.06 0 6.38-1.15 9.84-6.75 2.7-4.37 1.77-8.58-1.89-8.67-1.31.09-15.66 3.3-13.9 9.65M28.64 5.77a15.44 15.44 0 0 0-17.35-1.89c-.22.12-.44.23-.65.36l.05.02c-.64.44-1.19.96-1.64 1.55-4.46 5.9 10.49 10.2 18.48 10.21 3.67 2.64 4.7-7.45 1.11-10.25"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#5493F7",
    d: "M12.95 5.52c-2.02 2.97-8.75 5.06-9.86 4.73v-.01A15.64 15.64 0 0 1 8.02 4.5c.42-.3.85-.58 1.29-.83.94-.54 1.9-.57 2.22-.58 3 .05 1.44 2.4 1.42 2.43m-1.7 22.24c.15.97 0 4.83-.2 5.15-.18.01-.54.03-1.59-.55a16.75 16.75 0 0 1-7.58-9.1 16.18 16.18 0 0 1 .18-10.92c1.2 1.58 2.6 3.01 3.78 4.6 1.13 1.53 2.68 4 3 4.53 1.95 3.29 2.26 5.31 2.41 6.29m23.72-9.54c0 2.11-.42 4.13-1.17 5.98-2 2.05-15.42-3.01-15.55-3.07-1.84-.77-7.43-3.13-7.93-6.82-.73-5.32 10.5-9.03 15.43-9.17.6.01 2.4.03 3.44.85a15.95 15.95 0 0 1 5.78 12.23m-8.7 14.4c-1.4.67-2.95.18-2.55-1.24.77-2.72 7.5-5.51 8.98-5.66.19-.02.26.1.18.26a16.66 16.66 0 0 1-6.61 6.63"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerra);
export default __webpack_public_path__ + "static/media/Terra.152563e4.svg";
export { ForwardRef as ReactComponent };